import { styled } from '@mui/system'
import { ControlledDropdown as BHControlledDropdown } from '../dropdown'
import { Stack as MuiStack } from '@mui/material'
import Typography from '../../atoms/typography'

const shouldForwardProp = (prop) => prop !== 'notInStockOrNotAvailable'

const Container = styled('div')`
	position: relative;
	.MuiFormLabel-root {
		position: relative;
		transform: none;
		font-family: var(--font-alternative-regular);
		margin-bottom: 0;
		text-transform: none;
		font-size: var(--font-size-body1);

		&.Mui-focused,
		&.MuiFormLabel-filled {
			transform: none;
		}

		.MuiFormLabel-asterisk {
			display: none;
		}
	}
	.MuiSelect-select {
		&:focus {
			background: transparent;
		}
	}
`

const ControlledDropdown = styled(BHControlledDropdown)``

const Stack = styled(MuiStack)`
	width: 100%;
`

const OptionStyled = styled(Typography, { shouldForwardProp })`
	${({ notInStockOrNotAvailable }) => (notInStockOrNotAvailable ? `color: rgba(0, 0, 0, 0.4);` : null)}
`

const Label = styled(Typography)`
	color: rgba(0, 0, 0, 0.4);
	font-weight: ${({ theme }) => theme.typography.fontWeightBold};
	text-transform: uppercase;
`

export { Container, ControlledDropdown, Label, OptionStyled, Stack }
